import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('speedway', {
  cherry: 'hover_tire',
  lemon: 'turbo_cell',
  orange: 'checkered_flag',
  bell: 'lap_bell',
  star: 'hovercar_wild',
  seven: 'speedometer',
  gem: 'nitro_gem',
  scatter: 'race_cup_scatter',
  money: 'prize_purse',
});

/** Speedway — GENERATED by scaffoldSlot from
 *  content/slots/speedway.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const SPEEDWAY_THEME: Theme = {
  id: 'speedway',
  name: 'Speedway',
  palette: {
    accent: 0x2090e0,
    secondary: 0x6ab8f0,
    warm: 0xf2d27a,
    frameFill: 0x0e1a26,
    bgGradientTop: 0x163348,
    bgGradientBottom: 0x060f18,
    dimOverlay: 0x03070c,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Hover Tire', glyph: '⭕', tint: 0x303038, weight: 5, textureAlias: 'speedway:cherry',
        winVideoAlias: 'speedway:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Turbo Cell', glyph: '⚡', tint: 0x40b0e0, weight: 5, textureAlias: 'speedway:lemon',
        winVideoAlias: 'speedway:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Finish Flag', glyph: '🏁', tint: 0xc0c0c0, weight: 4, textureAlias: 'speedway:orange',
        winVideoAlias: 'speedway:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Lap Bell', glyph: '🔔', tint: 0xd0c0c8, weight: 3, textureAlias: 'speedway:bell',
        winVideoAlias: 'speedway:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Speedway', glyph: '🏎️', tint: 0x2090e0, weight: 2, textureAlias: 'speedway:star',
        winVideoAlias: 'speedway:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Redline', glyph: '🎛️', tint: 0xd03030, weight: 2, textureAlias: 'speedway:seven',
        winVideoAlias: 'speedway:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Nitro', glyph: '💎', tint: 0x40a0e0, weight: 2.5, textureAlias: 'speedway:gem',
        winVideoAlias: 'speedway:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Cup', glyph: '🏆', tint: 0xf0c040, weight: 0.5, textureAlias: 'speedway:scatter',
        winVideoAlias: 'speedway:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Prize Purse', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'speedway:money',
        winVideoAlias: 'speedway:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x0e1a26, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x2090e0, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x0e1a26, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x6ab8f0, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x2090e0, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x0e1a26, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x2090e0, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'speedway:bg', path: 'environment/speedway.png' },
      columnBackground: { alias: 'speedway:column_bg', path: 'reel/speedway_column_bg.png' },
      border: { alias: 'speedway:border', path: 'brand/border_neon.png' },
    },
  },
};
